import { getField } from 'vuex-map-fields';

export default {
  integrations: state => state.integrations,
  frontTeams: state => state.frontTeams,
  integrationsLoaded: state => state.integrationsLoaded,
  integrationDeleted: state => state.integrationDeleted,
  frontTeamsLoaded: state => state.frontTeamsLoaded,
  frontToken: state => state.frontToken,
  frontTokenLoaded: state => state.frontTokenLoaded,
  frontIntegrated: state => state.frontIntegrated,
  apiError: state => state.apiError,
  getField,
};
